import { JSX } from 'react'

export const withClient = <Type>(component: (props: Type) => JSX.Element) => {
  return component
}
